import { ActionReducerMap, combineReducers, createFeatureSelector } from '@ngrx/store';

import { AnnouncementEffects } from './announcements/store/announcement.effects';
import { announcementReducer, AnnouncementsState } from './announcements/store/announcement.reducer';
import { ArchiveEffects } from './archive/store/archive.effects';
import { archiveReducer, ArchiveState } from './archive/store/archive.reducer';
import { CalendarEffects } from './calendar/store/calendar.effects';
import { calendarReducer, CalendarState } from './calendar/store/calendar.reducer';
import { DecreesEffects } from './decrees/store/decrees.effects';
import { decreesReducer, DecreesState } from './decrees/store/decrees.reducer';
import { DossierEffects } from './dossiers/store/dossiers.effects';
import { dossierReducer, DossierState } from './dossiers/store/dossiers.reducer';
import { FollowupEffects } from './followup/store/followup.effects';
import { followupReducer, FollowupState } from './followup/store/followup.reducer';
import { GenericWidgetDataEffects } from './generic-widget-data/store/generic-widget-data.effects';
import { genericWidgetDataReducer } from './generic-widget-data/store/generic-widget-data.reducer';
import { IGenericWidgetDataState } from './generic-widget-data/store/generic-widget-data.types';
import { HolidayEffects } from './holiday/store/holiday.effects';
import { holidayReducer, HolidayState } from './holiday/store/holiday.reducer';
import { MeetingEffects } from './meeting/store/meeting.effects';
import { meetingReducer, MeetingState } from './meeting/store/meeting.reducer';
import { PresenceReportEffects } from './presence-report/store/presence-report.effects';
import { presenceReportReducer, PresenceReportState } from './presence-report/store/presence-report.reducer';
import { SearchEffects } from './search/store/search.effects';
import {
  exportsReducerFunction,
  ExportsState,
  ISearchModuleState,
  queryReducerFunction,
  QueryState,
  searchReducerFunction,
  SearchState
} from './search/store/search.reducer';
import { TabsEffects } from './tabs/store/tabs.effects';
import { tabsReducer, TabsState } from './tabs/store/tabs.reducer';
import { ThemeEffects } from './theme/store/theme.effects';
import { themeReducer, ThemeState } from './theme/store/theme.reducer';
import { UserDataEffects } from './userdata/store/userdata.effects';
import { userDataReducer, UserDataState } from './userdata/store/userdata.reducer';
import { WidgetsEffects } from './widgets/store/widgets.effects';
import { widgetsReducer, WidgetsState } from './widgets/store/widgets.reducer';
import { WrittenQuestionsEffects } from './written-questions/store/written-questions.effects';
import { writtenQuestionsReducer, WrittenQuestionsState } from './written-questions/store/written-questions.reducer';

export interface IState {
  repository: IRepositoryState;
}

export interface IRepositoryState {
  tabs: TabsState;
  widgets: WidgetsState;
  genericWidgetData: IGenericWidgetDataState;
  searchModule: {
    search: SearchState;
    query: QueryState;
    exports: ExportsState;
  };
  userData: UserDataState;
  announcements: AnnouncementsState;
  writtenQuestions: WrittenQuestionsState;
  holidays: HolidayState;
  calendar: CalendarState;
  meeting: MeetingState;
  archive: ArchiveState;
  dossiers: DossierState;
  presenceReport: PresenceReportState;
  followupTasks: FollowupState;
  theme: ThemeState;
  decrees: DecreesState;
}

export const REDUCERS: ActionReducerMap<IRepositoryState> = {
  tabs: tabsReducer,
  widgets: widgetsReducer,
  genericWidgetData: genericWidgetDataReducer,
  searchModule: combineReducers<ISearchModuleState>({
    search: searchReducerFunction,
    query: queryReducerFunction,
    exports: exportsReducerFunction
  }),
  announcements: announcementReducer,
  writtenQuestions: writtenQuestionsReducer,
  userData: userDataReducer,
  holidays: holidayReducer,
  archive: archiveReducer,
  dossiers: dossierReducer,
  presenceReport: presenceReportReducer,
  calendar: calendarReducer,
  meeting: meetingReducer,
  followupTasks: followupReducer,
  theme: themeReducer,
  decrees: decreesReducer
};

export const EFFECTS = [
  TabsEffects,
  WidgetsEffects,
  GenericWidgetDataEffects,
  SearchEffects,
  AnnouncementEffects,
  WrittenQuestionsEffects,
  UserDataEffects,
  HolidayEffects,
  ArchiveEffects,
  DossierEffects,
  PresenceReportEffects,
  CalendarEffects,
  MeetingEffects,
  FollowupEffects,
  ThemeEffects,
  DecreesEffects
];

export const REPOSITORY_SELECTOR = createFeatureSelector<IRepositoryState>('repository');
